export default __webpack_public_path__ + "static/media/2w.da750257.svg";